import { StyledFullPageWrapper, StyledSpinner } from './styles';

const FullPageLoader = () => (
    <StyledFullPageWrapper>
      <StyledSpinner className='loader' />
    </StyledFullPageWrapper>
  );

export default FullPageLoader;
